<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">Definicje faktur</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">{{ facture.id }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('factures.edit', {'client':facture.client_id,'facture':facture.id})">Pozycja</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      {{ position.id }}
    </h1>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          
          <multiselect-input v-model="form.cycle" :error="form.errors.cycle" label="Cykl" :options="cycles" class="pr-6 pb-8 w-full lg:w-1/2" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" :searchable="false" />

          <text-input v-model="form.cycle_from" :error="form.errors.cycle_from" class="pr-6 pb-8 w-full lg:w-1/2" label="Data wystawienia" type="date" />

          <multiselect-input v-model="form.article" :error="form.errors.article" label="Artykuł" :options="articles" class="pr-6 pb-8 w-full lg:w-1/2" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" :searchable="false" @input="onChangeArticle" />

          <text-input v-model="form.ilosc" :error="form.errors.ilosc" class="pr-6 pb-8 w-full lg:w-1/2" label="Ilość" type="number" min="1" max="100" />

          <template v-if="form.article != null">
            <text-input v-model="form.cena_netto" :error="form.errors.cena_netto" class="pr-6 pb-8 w-full lg:w-1/3" label="Cena netto" type="number" step="0.01" />
            <text-input v-model="form.vat_sprzedazy" :error="form.errors.vat_sprzedazy" class="pr-6 pb-8 w-full lg:w-1/3" label="Vat [%]" type="number" />
            <text-input v-model="form.cena_brutto" :error="form.errors.cena_brutto" class="pr-6 pb-8 w-full lg:w-1/3" label="Cena brutto" type="number" step="0.01" />
          </template>
          
          <shtax-text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.notice" :error="form.errors.notice" label="Opis na pozycji" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="$page.props.can['delete factures']" class="text-red-600 hover:underline mr-5" tabindex="-1" type="button" @click="destroy">Usuń pozycję</button>
          <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zaktualizuj dane</loading-button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import Icon from '@/Shared/Icon'
import Swal from 'sweetalert2'

export default {
  metaInfo() {
    return {
      title: `Pozycja ${this.position.id} faktury ${this.facture.id}`,
    }
  },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    MultiselectInput,
    TrashedMessage,
    Icon
  },
  layout: Layout,
  props: {
    facture: Object,
    position: Object,
    articles: Array,
    cycles: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        cycle: this.position.cycle,
        cycle_from: this.position.cycle_from,
        article: this.position.artykul,
        ilosc: this.position.ilosc,
        cena_netto: this.position.cena_netto,
        cena_brutto: this.position.cena_brutto,
        vat_sprzedazy: this.position.artykul.VAT_SPRZEDAZY.trim(),
        notice: this.position.opis
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('factures.positions.update', {'facture':this.facture.id, 'position':this.position.id}))
    },
    destroy() {
      Swal.fire({
        title: 'Jesteś pewny że chcesz usunąć wybraną pozycję faktury?',
        text: 'Przywrócenie usuniętej pozycji nie będzie już możliwe',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('factures.positions.destroy', {'facture':this.facture.id, 'position':this.position.id}))
        }
      })
    },

    onChangeArticle() {

      this.form.cena_netto = this.form.article.cena_detal.CENA_NETTO
      this.form.cena_brutto = this.form.article.cena_detal.CENA_BRUTTO
      this.form.vat_sprzedazy = this.form.article.VAT_SPRZEDAZY.trim()
    }
  },

  computed: {
    cena_netto() {
      return this.form.cena_netto 
    },

    cena_brutto() {
      return this.form.cena_brutto 
    }
  },

  watch: {
    cena_netto() {
      this.form.cena_brutto = Math.round(this.form.cena_netto*(1.0+(this.form.vat_sprzedazy/100.0)) * 100) /100 +''
    },
    cena_brutto() {
      this.form.cena_netto = Math.round(this.form.cena_brutto/(1.0+(this.form.vat_sprzedazy/100.0)) * 100) /100 +''
    }
  }
  
}
</script>
